import Component from "../qlib/Component";
import SimpleComponentRegistery from "../qlib/SimpleComponentRegistery";

export default class LightboxComponent extends Component {
    constructor(element)
    {
        super(element);

        this.item_selector = this.element.getAttribute("data-lightbox-selector") || ".js-lg-item";

        lightGallery(this.element, {
            thumbnail: true,
            selector: this.item_selector,
        });

        this.lightbox = lgData[this.element.getAttribute("lg-uid")];

        this.first_item = this.element.querySelector(this.item_selector);

        this.button = this.element.querySelector(".js-show-more");
        if (this.button === null) return;
        this.button.addEventListener("click", event => {
            event.preventDefault();
            this.first_item.click();
            this.lightbox.slide(0);
        })
    }
} 

SimpleComponentRegistery.register("lightbox", LightboxComponent);